import React, { memo } from "react";

const IconLogout = ({ color = "black", ...props }) => (
  <svg fill="none" {...props} width="20" height="20" viewBox="0 0 20 20">
    <path
      d="M17.25 10L8.75 10M17.25 10L14.25 6.75M17.25 10L14.25 13.25M9.25 1.75L4.75 1.75C3.64543 1.75 2.75 2.64543 2.75 3.75L2.75 16.25C2.75 17.3546 3.64543 18.25 4.75 18.25L9.25 18.25"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(IconLogout);
